
import Component from '../../../assets/scripts/modules/component';
import required from '../../../vendor/scripts/fabrique/modules/required';
import fireCustomEvent from '../../../vendor/scripts/fabrique/modules/fire-custom-event';

class Picture extends Component {

  constructor() {
    super(...arguments);
  }

  init() {

    this.observer = null;
    this.gallery = this.element.querySelector('.gallery')
    this.picture = this.element.querySelector('picture');
    this.img = this.element.querySelector('img');
    this.sources = [...this.element.querySelectorAll('source')];

    this.enableGallery();  // do this always, regardless of lazyload logic

    if (this.element.getAttribute('data-lazyload') === null || !this.picture || !this.img || !this.sources) {
      return;
    }

    this.element.removeAttribute('data-lazyload');

    // Set observers on next paint (otherwise it'll cause a forced layout reflow)
    window.requestAnimationFrame(() => this.attachObserver());

    // Allows for forcing the load, for example, when in a swiper and intersectionobserver is unreliable
    this.element.forceLoad = () => {
      this.loadImage();
      this.disconnectObserver();
      this.destroy();
      this.element.forceLoad = null;
    };

  }

  destroy() {

    this.sources = null;
    this.img = null;
    this.picture = null;
    this.observer = null;

  }

  attachObserver() {

    if (this.observer) {
      this.disconnectObserver();
    }

    // Set the rootMargin so we start intersecting halfway outside the viewport
    this.observer = new window.IntersectionObserver(this.onIntersect.bind(this), { rootMargin: `${window.innerHeight / 2}px` });
    this.observer.observe(this.img);

  }

  disconnectObserver() {

    if (!this.observer) {
      return;
    }

    this.observer.unobserve(this.img);
    this.observer.disconnect();
    this.observer = null;

  }

  onIntersect(entries = required()) {

    for (const entry of entries) {
      if (entry.intersectionRatio) {
        this.loadImage();
        this.disconnectObserver();
        this.destroy();
      }
    }

  }

  loadImage() {

    if (this.element.classList.contains('is-loading') || this.element.classList.contains('has-loaded')) {
      return;
    }

    this.element.classList.add('is-loading');

    // Dirty, but guaranteed to work. Changing <source> props is a bit fiddly
    this.picture.innerHTML = ' ';

    this.replaceSources();
    this.replaceImg();

    // Possible leak? requestAnimationFrame doesn't put it in the queue
    window.setTimeout(() => {
      this.element.classList.remove('is-loading');
      this.element.classList.add('has-loaded');
    }, 0);

  }

  replaceSources() {

    if (document.documentMode) {
      return; // Not for IE11
    }

    for (const source of this.sources) {
      const newSource = document.createElement('source');

      newSource.setAttribute('srcset', source.getAttribute('data-srcset'));

      if (source.getAttribute('media') !== null) {
        newSource.setAttribute('media', source.getAttribute('media'));
      }

      this.picture.appendChild(newSource);
    }

  }

  replaceImg() {
    const newImg = document.createElement('img');

    newImg.setAttribute('class', this.img.getAttribute('class'));
    newImg.src = (document.documentMode) ? this.img.getAttribute('data-src'): ' '; // Src cannot be empty

    // Add to DOM and reset reference
    this.img = this.picture.appendChild(newImg);

  }

  enableGallery() {

    if (this.element.hasAttribute('data-add-me-to-gallery')) {
      this.picture.classList.add('clickable-picture');
      this.picture.addEventListener('click', () => {
        let pictureindex = this.element.getAttribute('data-gallery-index');
        fireCustomEvent('gallery:open', {'pictureIndex': pictureindex});
      });
    }

  }

}

for (const element of document.querySelectorAll('.picture')) {
  element.instance = new Picture('picture', element, { onLoad: true });
}



// WEBPACK FOOTER //
// ./website/components/atoms/picture/picture.js